import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { FollowUpApplicationForm } from '@/follow-up-applications/FollowUpApplicationForm';

/**
 * Gravity Form 12, *Follow-Up Coordinator Application* — public and
 * unauthenticated (L1), which is why the routeId is on `useAuthCheck`'s
 * allowlist. That list is an EXACT-EQUALITY check, not a prefix match, so a
 * missing entry bounces an anonymous visitor to `/login` and the form is
 * unreachable.
 *
 * Top-level rather than under `_app`, matching `study-helper-application.tsx`:
 * the intake screens render without the app chrome, and only `_app.tsx` reads
 * `pageBackground` / `noContainer`. Both are carried anyway so the three intake
 * routes stay a single copy-paste apart.
 */
export const Route = createFileRoute('/follow-up-coordinator-application')({
  component: FollowUpCoordinatorApplicationPage,
  beforeLoad: () => {
    return {
      pageBackground: 'white',
      noContainer: true,
    };
  },
});

function FollowUpCoordinatorApplicationPage(): ReactElement {
  return <FollowUpApplicationForm applicationRole="coordinator" />;
}
